import React from 'react';
import TermsAndConditionPage from './TermsAndConditionPage';

const TermsAndConditionPageWrapper = () => {
  return <TermsAndConditionPage />;
};

export default TermsAndConditionPageWrapper;
